import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

export default function OnPageJumpTarget({ name }) {
  return (
    <Box sx={{ position: 'relative' }}>
      <Box
        component="a"
        id={name}
        sx={{ position: 'absolute', top: -100 }}
      />
    </Box>
  );
}

OnPageJumpTarget.propTypes = {
  name: PropTypes.string.isRequired,
};

OnPageJumpTarget.scrollToElement = (name) => {
  const element = document.getElementById(name);
  const offsetTop = getOffsetTop(element);

  window.scrollTo({
    top: offsetTop,
    left: 0,
    behavior: 'smooth',
  });
};

function getOffsetTop(element) {
  let offsetTop = 0;

  do {
    if (!Number.isNaN(element.offsetTop)) {
      offsetTop += element.offsetTop;
    }

    // eslint-disable-next-line no-param-reassign
    element = element.offsetParent;
  } while (element);

  return offsetTop;
}
